<mat-toolbar color="primary" class="apearAnimation flex-row flex content-between relative rounded-md">
  <span class="font-semibold">Clubes</span>
  
    <div class="absolute right-0 content-center">
      <ul class="flex-row flex content-center gap-2">
        <li>
          <button mat-icon-button (click)="openDialogCreate()">
            <mat-icon>add</mat-icon>
          </button>
        </li>
      </ul>
    </div>
  </mat-toolbar>
  
  <div class="margin-container apearAnimation">
    <!-- <app-tableusr></app-tableusr> -->
  
    <div class="flex flex-wrap items-baseline bg-stone-100 rounded-md pt-3 px-1 mb-2">
      <mat-form-field appearance="outline" class="w-full md:w-auto">
        <mat-label>Nombre del club</mat-label>
        <input
          matInput
          type="text"
          [(ngModel)]="searchString"
          (keyup.enter)="onEnter()"
        />
        <button
          *ngIf="searchString"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="searchString = ''"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>
  
    <div class="loading-indicator" *ngIf="isLoadingResults">
      <mat-spinner></mat-spinner>
    </div>
  
    <mat-form-field appearance="outline">
      <mat-label>Filtro</mat-label>
      <input matInput (keyup)="applyFilter($event)" placeholder="Filtro" #input />
    </mat-form-field>
  
    <div class="mat-elevation-z0 contenedorTabla" *ngIf="!isLoadingResults">
      <table mat-table [dataSource]="dataSource">
  
        <ng-container matColumnDef="razonSocial">
          <th mat-header-cell *matHeaderCellDef>Razón Social</th>
          <td mat-cell *matCellDef="let element">{{ element.razonSocial }}</td>
        </ng-container>
        <ng-container matColumnDef="fechaServicioHasta">
            <th mat-header-cell *matHeaderCellDef>Fecha Servicio Hasta</th>
            <td mat-cell *matCellDef="let element">{{ element.fechaServicioHasta | date: 'dd-MM-yyyy'}}</td>
          </ng-container>
  
        <ng-container matColumnDef="estado">
          <th mat-header-cell *matHeaderCellDef>Estado</th>
          <td mat-cell *matCellDef="let element">
            <label *ngIf="element.estado"> Activa </label>
            <label *ngIf="!element.estado"> inactiva </label>
          </td>
        </ng-container>

        <ng-container matColumnDef="saldo">
          <th mat-header-cell *matHeaderCellDef>Saldo</th>
            <td mat-cell *matCellDef="let element">{{ element.saldo | currency:'':'symbol':'1.0-0' }}</td>    
        </ng-container>

        <ng-container matColumnDef="contacto">
            <th mat-header-cell *matHeaderCellDef>Contacto</th>
            <td mat-cell *matCellDef="let element">
                <label>Email:  {{ element.email }}</label><br />
                <label>Cel:  {{ element.celular }}</label><br />
                <label>Tel:  {{ element.telefono }}</label>
            </td>
          </ng-container>

          <ng-container matColumnDef="direccion">
            <th mat-header-cell *matHeaderCellDef>Dirección</th>
            <td mat-cell *matCellDef="let element">{{ element.direccion }}</td>
          </ng-container>
  
        <ng-container matColumnDef="botones">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            

            <button
            color="primary"
            mat-icon-button
            aria-label="Edit"
            (click)="editFechaServicioEmpresa(element)"
          >
            <mat-icon>event</mat-icon>
          </button>

            <button
              color="accent"
              mat-icon-button
              aria-label="Edit"
              (click)="edit(element)"
            >
              <mat-icon>edit</mat-icon>
            </button>

            <button
            color="primary"
            mat-icon-button
            aria-label="Edit"
            (click)="editarSaldo(element)"
          >
            <mat-icon>wallet</mat-icon>
          </button>

                <button
            color="primary"
            mat-icon-button
            aria-label="Edit"
            (click)="listadoAdministradores(element)"
          >
            <mat-icon>group</mat-icon>
          </button>
  
            <button
              mat-icon-button
              color="accent"
              aria-label="AddAdministrador"
              mat-icon-button
              aria-label="AddAdministrador"
              (click)="addAdministrador(element)"
            >
              <mat-icon>face</mat-icon>
            </button>
          </td>
        </ng-container>
  
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
  
      <mat-paginator
        #paginator
        [length]="length"
        [pageIndex]="pageIndex"
        [pageSize]="pageSize"
        [pageSizeOptions]="[10, 25, 100]"
        (page)="getServerData($event)"
      ></mat-paginator>
    </div>
  </div>
  